import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LogService } from './log.service';


@Injectable({
  providedIn: 'root'
})
export class RequestService {
  modalIndicators:any;
  selectedAllIds:any;
  url = "https://niivsnes.humge.com";
  constructor(private http: HttpClient,private logService:LogService) { 
  }

  getRequests(): Observable<any> {
    return this.http.get(this.url+'/api/request?token='+localStorage.getItem('token'));
  }

  generateVinolabReq(data):Observable<any>{
    return this.http.post(this.url+'/api/generateLabReq?token='+localStorage.getItem('token'),data);
  }

  getReferenceNumber(): Observable<any> {
    return this.http.get(this.url+'/api/request/create?token='+localStorage.getItem('token'));
  }
  deleteRequest(id): Observable<any> {
    this.logService.log("Изтриване на заявка "+id).subscribe();
    return this.http.delete(this.url+'/api/request/' + id+'?token='+localStorage.getItem('token'));
  }
  saveRequest(request): Observable<any> {
    this.logService.log("Добавяне на заявка ").subscribe();
    return this.http.post(this.url+'/api/request?token='+localStorage.getItem('token'), request);
  }
  editRequest(id): Observable<any> {
    return this.http.get(this.url+'/api/request/' + id + '/edit?token='+localStorage.getItem('token'));
  }
  updateRequest(request, id): Observable<any> {
    this.logService.log("Промяна на заявка "+id).subscribe();
    return this.http.put(this.url+'/api/request/' + id+'?token='+localStorage.getItem('token'), request);
  }
  copyRequest(id): Observable<any> {
    this.logService.log("Копиране на заявка "+id).subscribe();
    return this.http.get(this.url+'/api/copyReq/' + id+'?token='+localStorage.getItem('token'));
  }
  getClients(){
    return this.http.get(this.url+'/api/getClients?token='+localStorage.getItem('token'));
  }

  clientInfo(data){
    return this.http.get(this.url+'/api/clientInfo/'+data+'?token='+localStorage.getItem('token'));
  }

  filterRequests(data){
    return this.http.post(this.url+'/api/filterRequests?token='+localStorage.getItem('token'),data);
  }

  getIndicatorPrice(data,id): Observable<any>{
    return this.http.post(this.url+'/api/getIndicatorPrice/'+id+'?token='+localStorage.getItem('token'),data);
  }

  getModalIndicators(id): Observable<any>{
    return this.http.get(this.url+'/api/getModalIndicators/'+id+'?token='+localStorage.getItem('token'));
  }

  setModalIndicators(data){
    this.modalIndicators = data;
  }

  setIndicatorsIds(data){
    this.selectedAllIds = data;
  }

  getIndicatorsIds(){
    return this.selectedAllIds;
  }

  modalIndicatorsGet(){
    return this.modalIndicators;
  }

}
